import { useCallback } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIIcon from 'UIComponents/icon/UIIcon';
import UIIconButton from 'UIComponents/button/UIIconButton';
import withUsageTracking from '../hoc/withUsageTracking';

// To match the height of settings and undo/redo buttons that would typically be
// placed next to this button
import { jsx as _jsx } from "react/jsx-runtime";
const SPOTLIGHT_BUTTON_STYLE = {
  lineHeight: '1em'
};
const EPSpotlightButton = ({
  'data-test-id': dataTestId = 'spotlight-button',
  name = 'search',
  onClick,
  onTrackUsage,
  size = 'small',
  tooltipKey = 'epSpotlight.openSpotlightButton'
}) => {
  const handleClick = useCallback(() => {
    onClick();
    onTrackUsage('open quickspot via click');
  }, [onClick, onTrackUsage]);
  return /*#__PURE__*/_jsx(UIIconButton, {
    "data-test-id": dataTestId,
    onClick: handleClick,
    size: size,
    style: SPOTLIGHT_BUTTON_STYLE,
    tooltip: /*#__PURE__*/_jsx(FormattedMessage, {
      message: tooltipKey
    }),
    children: /*#__PURE__*/_jsx(UIIcon, {
      name: name
    })
  });
};
export { EPSpotlightButton };
export default withUsageTracking(EPSpotlightButton);